import FileUpload from '@/js/components/fileUpload'
import Column from '@/js/components/column'
import Modal from '@/js/components/modal'
import ikkyuPlanGuideHtml from '@/html/ikkyu-plan-guide.html'

export const inputParticipantAction = () => {
    const modal = new Modal()
    $('.ikkyu-plan-guide-modal').on('click', () => {
        modal.setHtml(ikkyuPlanGuideHtml)
        modal.show()
    })

    class FileUploadPhotos extends FileUpload {
        loadedFile(element, reader) {
            $(element).find('figure').remove();
            let imgObj = $('<img />').attr('src', reader.result)
            imgObj = $('<figure />').addClass('photo uploading').append(imgObj);
            $(element).append(imgObj);
            $(element).find('.del').show();
        }

        uploadedFile(element, resp) {
            $(element).find('figure').removeClass('uploading')
            $(element).find('input.tmpImg').val(resp.data.key)

            this.setImgVal(element)
        }

        setImgVal(element) {
            const fieldObj = $(element).closest('.field')
            let photos = fieldObj.find('input.tmpImg').get().map(element => {
                return $(element).val()
            }).filter(_val => _val)
            fieldObj.find(`input[name="${this.settings.keyName}"]`).val(photos.join(','))
        }

        error(element) {
            $(element).find('figure').remove()
            alert('アップロードエラー')
        }
    }

    class FileUploadPhotoSingle extends FileUpload {
        uploadedFile(element, resp) {
            console.log(resp)
            $(element).find('figure').removeClass('uploading')
            $(element).find('input[type="hidden"]').val(resp.data.key)
        }
        deletedFile(element) {
            $(element).find('figure.photo').remove()
            return null
        }
    }

    class ColumnExtend extends Column {
        constructor(params, fileUpload) {
            super(params)
            this.fileUpload = fileUpload
        }
        addActionAfter(column) {
            this.fileUpload.addTargetObj(column.find('.photos').get(0))
        }
        editTmplObj(tmplObj) {
            tmplObj.find('.field.image > figure').remove()
            tmplObj.find('.error-message').remove()
            return tmplObj
        }
        delActionAfter() {
            this.fileUpload.setImgVal(this.settings.baseObj.get(0))
        }
        setCloneObj(obj) {
            obj.find('figure').remove()
        }
    }

    const currentYear = $('input[name="current_year"]').val();
    const fileUploadPhotos = new FileUploadPhotos({
        targetSelector: '.item-photos .photos',
        typeFilter: ['image/jpeg', 'image/png'],
        fileSizeLimit: 8,
        uploadDir: `${currentYear}/main`,
        token: $('input[name=_csrfToken]').val(),
        uploadPath: '/entry/api/file/upload',
        keyName: 'photos',
        deleteSelector: '.del_photo',
    })

    const fileUploadPhotoSingle = new FileUploadPhotoSingle({
        targetSelector: '.staff_photo',
        typeFilter: ['image/jpeg', 'image/png'],
        fileSizeLimit: 8,
        uploadDir: `${currentYear}/main`,
        token: $('input[name=_csrfToken]').val(),
        uploadPath: '/entry/api/file/upload',
        deleteType: 'dom',
        deleteConfirmMessage: 'このデータを削除します。よろしいですか？',
        addParams: {
            maxSize: [600, 600]
        }
    })

    const columnPhotos = new ColumnExtend({
        baseObj: $('.item-photos .columns'),
        maxSize: 5,
    }, fileUploadPhotos)

    // エリア選択
    let areaList
    $.ajax({
        url: '/entry/api/area',
        type: 'get',
        dataType: 'json',
    })
        .done(resp => {
            areaList = resp.data
            $('select.area_pref').on('change', e => {
                let pref = $(e.currentTarget).val()
                let cityList = areaList.area.filter(_val => {
                    let ptn = new RegExp('^' + pref + '_')
                    return _val.key.match(ptn)
                })

                $('select.area_city').children().slice(1).remove()
                cityList.forEach(_val => {
                    let optionObj = $('<option />').val(_val.key).text(_val.value)
                    $('select.area_city').append(optionObj)
                })
            })
            $('select.area_city').on('change', e => {
                let area = $(e.currentTarget).val()
                $('input[name="area"]').val(area)
            })
            let areaText = $('input[name="area"]').val()
            if (areaText) {
                areaText.split(',').forEach(_val => {
                    let keys = _val.split('_')
                    $('select.area_pref').val(keys[0]).trigger('change')
                    $('select.area_city').val(_val).trigger('change')
                })
            }
        })


    const autoCheck = (baseNameVal, baseNameEq, detailNameVal) => {
        // 自動チェック入力
        $(`input[name="${detailNameVal}"]`).on('keyup change', () => {
            $(`input[name="${baseNameVal}"]`).eq(baseNameEq).prop('checked', true)
        })

        //  内容が入力されたときはチェックは外せない
        $(`input[name="${baseNameVal}"]`).eq(baseNameEq).on('change', e => {
            if ($(e.currentTarget).prop('checked') == false) {
                if ($(`input[name="${detailNameVal}"]`).val()) {
                    //$(e.currentTarget).prop('checked', true)
                    $(`input[name="${detailNameVal}"]`).val('')
                }
            }
        })
    }

    autoCheck('appeal_point_lunch[]', 0, 'appeal_point_lunch1_add')
    autoCheck('appeal_point_lunch[]', 1, 'appeal_point_lunch3_add')
    autoCheck('appeal_point_dinner[]', 0, 'appeal_point_dinner1_add')
    autoCheck('appeal_point_dinner[]', 1, 'appeal_point_dinner3_add')

    // ディナーのフランス地方料理の選択項目制限(管理画面1次フォームは除外)
    $('.input-check-container:not(.js-cancel) input[name="dinner_add_special"][value="3"]').prop('disabled', true) // 3: ランチと同じフランス地方料理

    // ランチのフランス地方料理の詳細入力欄表示
    $('.input-check-container:not(.js-cancel) input[name="lunch_add_special"]').on('change', e => {
        if($(e.currentTarget).closest('section.form01').length){
            return true;
        }
        const val = $(e.currentTarget).val()
        if (val == '1') { // 1: フランス地方料理あり
            $('.lunch_add_special_detail').addClass('show')
            // ランチのフランス地方料理ありの場合はディナーのフランス地方料理の選択制限解除
            $('input[name="dinner_add_special"][value="3"]').prop('disabled', false)
        } else {
            $('.lunch_add_special_detail').removeClass('show')
            $('input[name="dinner_add_special"][value="3"]').prop('disabled', true).prop('checked', false)        
        }
    })
    $('.input-check-container:not(.js-cancel) input[name="lunch_add_special"]:checked').trigger('change')

    // ディナーのフランス地方料理の詳細入力欄表示
    $('.input-check-container:not(.js-cancel) input[name="dinner_add_special"]').on('change', e => {
        if($(e.currentTarget).closest('section.form01').length){
            return true;
        }
        const val = $(e.currentTarget).val()
        if (val == '4') { // 4: 別のフランス地方料理情報を入力
            $('.dinner_add_special_detail').addClass('show')
        } else {
            $('.dinner_add_special_detail').removeClass('show')
        }
    })
    $('.input-check-container:not(.js-cancel) input[name="dinner_add_special"]:checked').trigger('change')
}

const main = () => {
    if (!document.querySelector('#page-entry-participant-input')) return false;

    inputParticipantAction();
}
export default main;